module.exports = {
  "dynamic": {},
}



// WEBPACK FOOTER //
// ./src/i18n/dynamic/en.js